import TraderAccountTable from '../components/traderAccounts/TraderAccountTable'
import {
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import React, { useContext, useState } from 'react'
import TraderMoreInfo from '../components/traderAccounts/TraderMoreInfo'
import Box from '@mui/material/Box'
import { TraderAccountContext } from '../contexts/TraderAccountContext'
import {
  pageContainer,
  pageHeader,
  pageTitle,
  sectionCard,
  filterBar,
  adminColors,
} from '../adminStyles'

export default function TraderAccounts() {
  const [search, setSearch] = useState('')
  const [gtfSelected] = useState(false)
  const [greenchartSelected] = useState(false)
  const [searchType, setSearchType] = useState('email')

  const [trader, setTrader] = useState(null)
  const { setTraderAccount } = useContext(TraderAccountContext)
  const [showDetail, setShowDetail] = useState(false)

  function escapeRegex(s: string) {
    return s
  }

  function handleTraderSelect(val: any) {
    setTraderAccount(val)
    setTrader(val)
    setShowDetail(true)
  }

  function handleBack() {
    setShowDetail(false)
  }

  return (
    <Box sx={pageContainer}>
      <Box sx={pageHeader}>
        {showDetail ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              onClick={handleBack}
              size="small"
              sx={{
                color: adminColors.textSecondary,
                '&:hover': { color: adminColors.accent, bgcolor: adminColors.accentHover },
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
            <Box>
              <Typography sx={pageTitle}>
                {(trader as any)?.firstName || ''} {(trader as any)?.lastName || ''}
              </Typography>
              <Typography sx={{ fontSize: '0.8rem', color: adminColors.textSecondary }}>
                {(trader as any)?.email}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography sx={pageTitle}>Accounts</Typography>
        )}
      </Box>

      {/* Sliding container */}
      <Box sx={{ position: 'relative', overflow: 'hidden', minHeight: 0, flexGrow: 1 }}>
        {/* Search & Table view */}
        <Box
          sx={{
            transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease',
            transform: showDetail ? 'translateX(-100%)' : 'translateX(0)',
            opacity: showDetail ? 0 : 1,
            position: showDetail ? 'absolute' : 'relative',
            inset: showDetail ? 0 : undefined,
            display: 'flex',
            flexDirection: 'column',
            gap: 2.5,
            width: '100%',
          }}
        >
          <Box sx={sectionCard}>
            <Box sx={filterBar}>
              <RadioGroup
                row
                name="search-type-radio-buttons-group"
                defaultValue="email"
                sx={{ gap: 0.5 }}
              >
                {[
                  { value: 'email', label: 'Email' },
                  { value: 'gcid', label: 'GreenChart ID' },
                  { value: 'firstName', label: 'First Name' },
                  { value: 'lastName', label: 'Last Name' },
                ].map((opt) => (
                  <FormControlLabel
                    key={opt.value}
                    value={opt.value}
                    control={
                      <Radio size="small" sx={{ '&.Mui-checked': { color: adminColors.accent } }} />
                    }
                    label={<Typography sx={{ fontSize: '0.825rem' }}>{opt.label}</Typography>}
                    onChange={(val: any) => setSearchType(val.target.value)}
                    sx={{ mr: 2 }}
                  />
                ))}
              </RadioGroup>
            </Box>
            <Box sx={{ px: 2.5, py: 1.5 }}>
              <TextField
                onChange={(val: any) => setSearch(escapeRegex(val.target.value))}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: adminColors.textMuted, fontSize: 20 }} />
                    </InputAdornment>
                  ),
                }}
                fullWidth
                placeholder={`Search traders by ${searchType}...`}
                size="small"
                id="accountSearch"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '0.85rem',
                    borderRadius: '6px',
                  },
                }}
              />
            </Box>
          </Box>

          <TraderAccountTable
            searchString={search}
            searchField={searchType}
            gtfSearchSelected={gtfSelected}
            greenchartSearchSelected={greenchartSelected}
            trader={trader}
            traderUsermetaSelected={handleTraderSelect}
            style={{}}
          />
        </Box>

        {/* Detail view — slides in from right */}
        <Box
          sx={{
            transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease',
            transform: showDetail ? 'translateX(0)' : 'translateX(100%)',
            opacity: showDetail ? 1 : 0,
            position: showDetail ? 'relative' : 'absolute',
            inset: showDetail ? undefined : 0,
            width: '100%',
          }}
        >
          {trader && (
            <TraderMoreInfo
              trader={trader}
              onTraderUpdate={(updatedTrader: any) => {
                setTrader(updatedTrader)
                setTraderAccount(updatedTrader)
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}
